import Container from './ThreadOrderSelect.container';
import ThreadOrderSelect from './ThreadOrderSelect';

export default Container(ThreadOrderSelect);
